// @flow
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { FormattedMessage } from 'react-intl';
import { Route, Switch, Redirect } from 'react-router';
import { Link } from 'react-router-dom';
import PurchasesActivesContainer from '../containers/PurchasesActivesContainer';
import PurchasesPastsContainer from '../containers/PurchasesPastsContainer';
import Banner from '../../../elements/Banner/Banner';
import routes from '../../../routes';
import Page from '../../../Page';

import style from './Orders.scss';
import subNavStyle from '../../../assets/styles/sub-nav.scss';
import icons from '../../../assets/styles/icons.scss';

import type { LocalValuesState } from '../../local-values/duck';

type Props = {
  +location: {
    pathname: string;
  };
  +localValues: LocalValuesState;
};

export default class Orders extends Component<Props, void> {

  render() {
    const { location, localValues } = this.props;
    const subRoute = location.pathname.split('/')[2];
    return (
      <section className={style.ordersWrap}>
        <Banner translatedId="orders.header.title"
                color="blue"
                rightElement={
                  <Link to="/">
                    <i className={icons.iconBagAddMedium}/>
                    <FormattedMessage id="orders.nav.newOrder"/>
                  </Link>}/>
        <nav className={classNames(subNavStyle.subNav)}>
          <section>
            <ul>
              <li className={classNames({ [subNavStyle.active]: subRoute === 'active' })}>
                <FormattedMessage id="orders.nav.actives">{
                  txt => (<Link to="/orders/active">{txt}</Link>)
                }</FormattedMessage>
              </li>
              <li className={classNames({ [subNavStyle.active]: subRoute === 'past' })}>
                <FormattedMessage id="orders.nav.pasts">{
                  txt => (<Link to="/orders/past">{txt}</Link>)
                }</FormattedMessage>
              </li>
            </ul>
          </section>
        </nav>
        <Switch>
          <Redirect from={routes.ORDERS.routePath} exact to={routes.ORDERS.children.ACTIVE.routePath}/>
          <Route exact path={routes.ORDERS.children.ACTIVE.routePath}
                 render={props => <Page name={routes.ORDERS.children.ACTIVE.name}>
                   <PurchasesActivesContainer {...props}
                                              localValues={localValues}/>
                 </Page>}/>
          <Route exact path={routes.ORDERS.children.PAST.routePath}
                 render={props => <Page name={routes.ORDERS.children.PAST.name}>
                   <PurchasesPastsContainer {...props}
                                            localValues={localValues}/>
                 </Page>}/>
        </Switch>
      </section>
    );
  }
}

Orders.propTypes = {
  location: PropTypes.object.isRequired,
  localValues: PropTypes.object,
};



// WEBPACK FOOTER //
// ./src/modules/orders/components/Orders.jsx